/* tslint:disable */
/* eslint-disable */
export enum WorkReferralSource {
  Legacy = 'LEGACY',
  App = 'APP'
}
